import { render, staticRenderFns } from "./DashboardNewestProject.vue?vue&type=template&id=50491704&"
import script from "./DashboardNewestProject.vue?vue&type=script&lang=js&"
export * from "./DashboardNewestProject.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNewestProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports